import type { SxProps, Theme } from '@mui/material';

export const styles = {
    root: { minWidth: 360, p: 1 } as SxProps<Theme>,
    title: {
        color: 'grey.800',
        fontSize: '24px',
        fontWeight: 400,
        lineHeight: 'normal',
        mb: 2,
        ml: 1,
    } as SxProps<Theme>,
    tabsRow: { display: 'flex', gap: 1, mb: 2, ml: 1 } as SxProps<Theme>,
    tabBtn: (selected: boolean, theme: Theme): SxProps<Theme> => ({
        backgroundColor: selected ? theme.palette.blue[100] : theme.palette.grey[30],
        color: selected ? theme.palette.blue[800] : theme.palette.grey[500],
        textTransform: 'uppercase',
        borderRadius: '8px',
        px: 2,
        py: 0.5,
        fontWeight: 500,
        fontSize: '12px',
        '&:hover': {
            backgroundColor: theme.palette.blue[100],
            color: theme.palette.blue[800],
        },
    }),
    list: {
        maxHeight: '300px',
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
    } as SxProps<Theme>,
    listEmpty: {
        textAlign: 'center',
        py: 4,
        color: 'grey.500',
        fontSize: '14px',
    } as SxProps<Theme>,
    item: (theme: Theme): SxProps<Theme> => ({
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(1.5),
        gap: 1.5,
        borderBottom: `1px solid ${theme.palette.grey[50]}`,
        cursor: 'pointer',
        '&:hover': { background: theme.palette.grey[30] },
        '&:last-child': { borderBottom: 'none' },
    }),
    unreadDot: (theme: Theme) => ({
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        background: theme.palette.blue[700],
        flexShrink: 0,
    }),
    dotPlaceholder: { width: '8px', height: '8px', flexShrink: 0 } as SxProps<Theme>,
    iconCircle: (color: string): SxProps<Theme> => ({
        width: 36,
        height: 36,
        borderRadius: '50%',
        background: color,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        '& .MuiSvgIcon-root': { color: 'white', fontSize: 20 },
    }),
    itemText: { flex: 1, minWidth: 0 } as SxProps<Theme>,
    itemTitle: {
        fontWeight: 500,
        fontSize: '14px',
        color: 'grey.900',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    } as SxProps<Theme>,
    itemTime: { color: 'grey.500', fontSize: '12px' } as SxProps<Theme>,
    chevron: { color: 'grey.400', flexShrink: 0 } as SxProps<Theme>,
};
